import Styled from "styled-components";
import { maxQuery } from "../../../../helpers";

export default Styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    div.Orders_Details{
        background: #272B4A;
        border-radius: 5px;
        height:59px;
        margin-bottom:40px;
        display: flex;
        align-items: center;
        padding:28px;
        width:100%;
        }
        div.order__viewContainer{
            display:flex;
        }
        div.order_box{
            width: 300px;
            background: #272B4A;
            padding:25px;
            margin-bottom:25px
        }
        div.name{
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        margin-top:20px;
        color: #FF7B0D;
        }
        div.details{
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 160%
        color: rgba(255, 255, 255, 0.5);
        }
  
        `;
